






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

import ChartRawPronationSupinationAngles from '@/components/charts/walking/ChartRawPronationSupinationAngles.vue';
import ChartRawPronationSupinationFeet from '@/components/charts/walking/ChartRawPronationSupinationFeet.vue';

@Component({
  components: { ChartRawPronationSupinationAngles, ChartRawPronationSupinationFeet },
})
export default class PatientAcquisitionExportationFrameWalkingContainerChartRawPronationSupinationAngles extends Vue {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;
  @Prop({ required: true }) private modeIsAdvanced!: boolean;

  angles: any = ['heelStrike', 'toesStrike', 'heelOff', 'toesOff'];
}
